
    $(document).ready(function(){

      $('body').on('click', '.leftPanel .menuItem', function(e){
        $('.leftPanel .menuItem').removeClass('active');
        $(e.currentTarget).addClass('active');
        $('html,body').animate({ scrollTop: 0 }, 'fast');
      });

    });
